import React, { type RefObject } from 'react';

import { Button, Icon, Wrapper } from './styles';

interface NewItemsButtonProps {
    newItemsCount: number;
    scrollRef: RefObject<HTMLDivElement>;
}

export const NewItemsButton = ({ newItemsCount, scrollRef }: NewItemsButtonProps) => {
    const handleClick = () => {
        scrollRef?.current?.scrollTo(0, 0);
    };

    return (
        <Wrapper
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            onClick={handleClick}
        >
            <Button>
                <Icon /> {newItemsCount} new updates
            </Button>
        </Wrapper>
    );
};
